<template>
  <div>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else>
      <v-layout class="form-control">
        <template v-if="possibleOutput && possibleOutput.length > 0 && isAutofill">
          <multiselect
            v-model="caseB"
            :options="possibleOutput"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            @input="onChange"
          ></multiselect>
        </template>
        <template v-else>
          <input type="text" v-model="caseB" @blur="onChangeInput" />
          <intent-manage-prefill
            @addIntentPrefill="addIntentPrefill($event)"
          ></intent-manage-prefill>
        </template>
        <v-checkbox
          v-if="possibleOutput && possibleOutput.length > 0"
          v-model="isAutofill"
          color="primary"
          class="ma-2"
          style="display: inline-block;"
        ></v-checkbox>

        <v-dialog persistent v-model="showVariable" max-width="600" style="overflow: visible;">
          <v-card>
            <div class="text-xs-right">
              <v-btn fab flat small @click="onCancelVariable">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-text :style="{ 'min-height': showDropdown ? '350px' : 'auto' }">
              <multiselect
                v-model="selectedVariable"
                :options="filterVariable"
                :searchable="true"
                track-by="name"
                label="name"
                @input="onChange"
                @open="showDropdown = true"
                @close="showDropdown = false"
                :max-height="250"
              ></multiselect>

              <div class="text-xs-center">
                <v-btn outline color="grey" @click="onCancelVariable">{{ $t('cancel') }}</v-btn>
                <v-btn depressed color="primary" @click="onSaveVariable">{{ $t('Save') }}</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import IntentManagePrefill from './IntentManagePrefill'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: ['value', 'datatype'],
  data() {
    return {
      caseB: '',
      possibleOutput: [],
      loading: true,
      isAutofill: true,
      showVariable: false,
      selectedVariable: '',
      showDropdown: false
    }
  },
  components: {
    Multiselect,
    IntentManagePrefill
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      var variable = []
      if (vm.variable) {
        variable = vm.variable.filter(el => {
          return el.flowid == 0 || (this.selectedFlow && el.flowid == this.selectedFlow.id)
        })
      }
      var result = []
      variable.map(el => {
        result.push({
          name: el.name,
          value: el.name
        })
      })
      return result
    }
  },
  mounted() {
    var vm = this
    vm.caseB = vm.value
    vm.loading = true
    api.getVariablePossibleOutput({ name: vm.datatype }, function(error, response) {
      if (error) {
        console.error(error)
        vm.loading = false
        return
      }
      if (response.responsecode == 200 && response.description != '') {
        vm.possibleOutput = response.description.split(',')
        var currentOutput = vm.possibleOutput.find(pout => {
          return pout == vm.caseB
        })
        if (!currentOutput) {
          vm.isAutofill = false
        }
      }
      vm.loading = false
    })
  },
  methods: {
    onCancelVariable() {
      this.showVariable = false
      this.selectedVariable = ''
    },
    onSaveVariable() {
      var vm = this
      vm.caseB = '{' + vm.selectedVariable.value + '}'
      this.showVariable = false
      this.selectedVariable = ''
    },
    onChangeInput() {
      var caseB = ''

      try {
        caseB = this.caseB
        if (caseB != '') {
          caseB = caseB.replace(/[=]/g, '')
          this.caseB = caseB
        }
      } catch (error) {}
      this.$emit('input', this.caseB)
      this.$emit('onChange')
    },
    onChange(type) {
      // console.log(type)
      this.caseB = type
      this.$emit('input', type)
      this.$emit('onChange')
    },
    addIntentPrefill(payload) {
      if (payload == 'variable') {
        this.showVariable = true
      } else {
        this.caseB = '{' + payload + '}'
        this.$emit('input', this.caseB)
        this.$emit('onChange')
      }
    }
  },
  watch: {
    isAutofill(newVal) {
      if (newVal) {
        this.caseB = null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/DynamicUpdateVariable.vue